export const BASE_URL = process.env.REACT_APP_BASE_URL
export const FILE_UPLOAD_URL = process.env.REACT_APP_FILE_UPLOAD_URL
export const API_URL = process.env.REACT_APP_API_URL
export const ENVIRONMENT = process.env.REACT_APP_ENV
export const WS_URL = process.env.REACT_APP_WEBSOCKET_URL
